import { ReactNode } from 'react';
import classnames from 'classnames';
import { REVEAL_TIME_MS, CharStatus } from 'utils/wordle.utils';

type Props = {
    children?: ReactNode;
    solution: string;
    value: string;
    width?: number;
    status?: CharStatus;
    onClick: (value: string) => void;
    isRevealing?: boolean;
};

export const Key = ({ solution, children, status, width = 40, value, onClick, isRevealing }: Props) => {
    const keyDelayMs = REVEAL_TIME_MS * solution.length;

    const classes = classnames(
        'flex items-center justify-center rounded mx-0.5 text-xs font-bold cursor-pointer select-none',
        {
            'transition ease-in-out': isRevealing,
            'bg-slate-200 hover:bg-slate-300 active:bg-slate-400': !status,
            'bg-slate-400 text-white': status === 'absent',
            'bg-green-500 hover:bg-green-600 active:bg-green-700 text-white': status === 'correct',
            'bg-yellow-500 hover:bg-yellow-600 active:bg-yellow-700 text-white': status === 'present',
        }
    );

    const styles = {
        transitionDelay: isRevealing ? `${keyDelayMs}ms` : 'unset',
        width: `${width}px`,
        height: '58px',
    };

    const handleClick: React.MouseEventHandler<HTMLButtonElement> = event => {
        onClick(value);
        event.currentTarget.blur();
    };

    return (
        <button style={styles} aria-label={`${value} ${status}`} className={classes} onClick={handleClick}>
            {children || value}
        </button>
    );
};
